{
  "name": "@knocklabs/agent-toolkit",
  "version": "0.5.7",
  "description": "A toolkit for working with Knock in Agent workflows.",
  "main": "./dist/modelcontextprotocol/index.js",
  "types": "./dist/modelcontextprotocol/index.d.ts",
  "scripts": {
    "build": "tsup --env.NODE_ENV production",
    "clean": "rimraf ./dist",
    "dev": "tsup --watch",
    "lint": "eslint src --ext .ts,.tsx",
    "lint:fix": "eslint src --ext .ts,.tsx --fix",
    "format": "prettier --write \"src/**/*.{ts,tsx}\"",
    "format:check": "prettier --check \"src/**/*.{ts,tsx}\"",
    "test": "vitest run",
    "test:watch": "vitest",
    "release": "npm run build && npm run release:publish && changeset tag",
    "release:publish": "npm publish --access public --tolerate-republish"
  },
  "author": "Knock",
  "license": "MIT",
  "sideEffects": false,
  "type": "module",
  "exports": {
    ".": {
      "types": "./dist/modelcontextprotocol/index.d.ts",
      "default": "./dist/modelcontextprotocol/index.js"
    },
    "./openai": {
      "types": "./dist/openai/index.d.ts",
      "default": "./dist/openai/index.js"
    },
    "./ai-sdk": {
      "types": "./dist/ai-sdk/index.d.ts",
      "default": "./dist/ai-sdk/index.js"
    },
    "./langchain": {
      "types": "./dist/langchain/index.d.ts",
      "default": "./dist/langchain/index.js"
    },
    "./mastra": {
      "types": "./dist/mastra/index.d.ts",
      "default": "./dist/mastra/index.js"
    },
    "./modelcontextprotocol": {
      "types": "./dist/modelcontextprotocol/index.d.ts",
      "default": "./dist/modelcontextprotocol/index.js"
    },
    "./human-in-the-loop": {
      "types": "./dist/human-in-the-loop/index.d.ts",
      "default": "./dist/human-in-the-loop/index.js"
    },
    "./types": {
      "types": "./dist/types.d.ts"
    },
    "./core": {
      "types": "./dist/core/index.d.ts",
      "default": "./dist/core/index.js"
    }
  },
  "bin": {
    "agent-toolkit": "dist/modelcontextprotocol/local-server.js",
    "local-mcp": "dist/modelcontextprotocol/local-server.js"
  },
  "files": [
    "dist"
  ],
  "dependencies": {
    "@knocklabs/mgmt": "^0.24.0",
    "@knocklabs/node": "^1.10.3",
    "@modelcontextprotocol/sdk": "^1.7.0",
    "@sentry/node": "^10.5.0",
    "json-schema-to-zod": "^2.6.1",
    "uuid": "^11.1.0",
    "yargs": "^17.7.2",
    "zod": "^3.24.2",
    "zod-to-json-schema": "^3.24.5"
  },
  "devDependencies": {
    "@changesets/cli": "^2.28.1",
    "@eslint/js": "^9.24.0",
    "@langchain/core": "^0.3.45",
    "@types/node": "^22.13.10",
    "@types/yargs": "^17.0.33",
    "@typescript-eslint/eslint-plugin": "^8.29.1",
    "@typescript-eslint/parser": "^8.29.1",
    "ai": "^4.2.8",
    "eslint": "^9.24.0",
    "eslint-config-prettier": "^10.1.2",
    "eslint-import-resolver-typescript": "^4.3.2",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-prettier": "^5.2.6",
    "openai": "^4.90.0",
    "prettier": "^3.5.3",
    "rimraf": "^6.0.1",
    "ts-node": "^10.9.2",
    "tsup": "^8.4.0",
    "typescript": "^5.8.2",
    "typescript-eslint": "^8.29.1",
    "vitest": "^1.3.1"
  },
  "peerDependencies": {
    "@mastra/core": "^0.10.3",
    "ai": "^4.0.0",
    "openai": "^4.0.0"
  },
  "peerDependenciesMeta": {
    "ai": {
      "optional": true
    }
  },
  "engines": {
    "node": ">=20"
  },
  "publishConfig": {
    "access": "public"
  }
}
